import React from 'react'
import BankDetails from '../../components/BankDetails.jsx/BankDetails'
import "./BankDetails.css"
export const BankDetailsPage = () => {
  return (
    <div>
        <BankDetails/>
    </div>
  )
}
